"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = exports.Headline = exports.ErrorPizza = exports.Box = void 0;

var _react = _interopRequireDefault(require("react"));

var _tslib = require("tslib");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _slice = require("@lce/slice");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ErrorSvg = function ErrorSvg(props) {
  return _react["default"].createElement("svg", props, _react["default"].createElement("path", {
    d: "M268.17 207.11c-69.65 0-135.25-6.74-184.72-18.98C28.08 174.42 0 155.82 0 132.84s28.08-41.58 83.45-55.28c49.47-12.24 115.07-18.98 184.72-18.98s135.25 6.74 184.72 18.98c55.37 13.7 83.45 32.3 83.45 55.28s-28.08 41.58-83.45 55.28c-49.47 12.24-115.07 18.99-184.72 18.99zm0-127.54c-68 0-131.81 6.52-179.67 18.37-53.29 13.19-67.5 28.14-67.5 34.9s14.21 21.71 67.49 34.9c47.87 11.85 111.67 18.37 179.67 18.37s131.81-6.52 179.67-18.37c53.28-13.19 67.49-28.14 67.49-34.9s-14.21-21.71-67.49-34.9C399.97 86.1 336.16 79.57 268.17 79.57z"
  }), _react["default"].createElement("path", {
    fill: "#FFF",
    d: "M268.17 79.57c-68 0-131.81 6.52-179.67 18.37-53.29 13.19-67.5 28.14-67.5 34.9s14.21 21.71 67.49 34.9c47.87 11.85 111.67 18.37 179.67 18.37s131.81-6.52 179.67-18.37c53.28-13.19 67.49-28.14 67.49-34.9s-14.21-21.71-67.49-34.9C399.97 86.1 336.16 79.57 268.17 79.57z"
  }), _react["default"].createElement("path", {
    fill: "#FF671B",
    d: "M207.05 150.74c-12.72-2.25-25.42-5.03-37.61-8.08.93-1.98 1.59-4.07 1.9-6.17 1.63-11.16-11.89-19.33-21.45-20.68-5.83-.82-13.78.37-19.58 3.9-3.62 2.2-6.37 5.58-7.23 9.56-17.57-5.74-31.36-11.03-38.57-14.24-1.2-.53-3-2.04-1.72-4.69 6.63-13.69 33.66-67.63 45.94-85.06 12.55 11.59 45.45 37.6 84.08 66.1-4.03.87-8.05 2.44-11.25 4.89-3.91 3-6.34 7.47-6.43 12.44-.16 8.88 7.55 16.46 15.12 19.91 6.28 2.86 14.22 3.84 21.23 2.04.17 1.02.36 2.05.63 3.11-11.32-.22-21.42 7.47-25.06 16.97z"
  }), _react["default"].createElement("ellipse", {
    cx: "390.6",
    cy: "119.81",
    rx: "7",
    ry: "5"
  }), _react["default"].createElement("ellipse", {
    cx: "341.6",
    cy: "117.81",
    rx: "7",
    ry: "5"
  }), _react["default"].createElement("ellipse", {
    cx: "384.6",
    cy: "137.81",
    rx: "7",
    ry: "5"
  }), _react["default"].createElement("ellipse", {
    cx: "439.6",
    cy: "115.81",
    rx: "7",
    ry: "5"
  }), _react["default"].createElement("ellipse", {
    cx: "308.6",
    cy: "97.81",
    rx: "7",
    ry: "5"
  }), _react["default"].createElement("path", {
    fill: "#ED680F",
    d: "M247.65 115.72l-.87-.57c-.21 1.2-.54 2.37-.97 3.51.55-1.02 1.16-2 1.84-2.94z"
  }), _react["default"].createElement("path", {
    d: "M155.95 94.43c-8.1 3.18-17.09-.49-23.2-6.04-5.93-5.38-12.3-15.58-7.2-23.42 2.04-3.13 5.12-5.1 8.59-6.14 4.72-1.43 10.16-1.15 14.63.22 6.7 2.05 12.54 6.68 16.34 12.55 5.98 9.27.41 19.07-9.16 22.83z"
  }), _react["default"].createElement("path", {
    d: "M266.3 103.11c-31.95-20.42-76.35-51.87-126.22-96.37-12.48-10.3-20.12-7.17-27.16-1.35-9.03 7.2-59.54 100.61-58.54 102.38-4.56 9.44-.53 20.61 9.08 24.93 22 9.34 89.63 30.49 118.39 35.32 9.21 1.5 21.11 3.34 29.55 4.39 5.25.77 13.25 1.6 14.08 1.4-7.7-24.57 12.86-30.16 26.36-23.47.6.3 1.33-.04 1.02-.81-3.64-9.02-13.99-40.79 27.17-38.62-5.21-3.04-9.4-5.47-13.73-7.8zm-59.25 47.63c-12.72-2.25-25.42-5.03-37.61-8.08.93-1.98 1.59-4.07 1.9-6.17 1.63-11.16-11.89-19.33-21.45-20.68-5.83-.82-13.78.37-19.58 3.9-3.62 2.2-6.37 5.58-7.23 9.56-17.57-5.74-31.36-11.03-38.57-14.24-1.2-.53-3-2.04-1.72-4.69 6.63-13.69 33.66-67.63 45.94-85.06 12.55 11.59 45.45 37.6 84.08 66.1-4.03.87-8.05 2.44-11.25 4.89-3.91 3-6.34 7.47-6.43 12.44-.16 8.88 7.55 16.46 15.12 19.91 6.28 2.86 14.22 3.84 21.23 2.04.17 1.02.36 2.05.63 3.11-11.32-.22-21.42 7.47-25.06 16.97z"
  }));
};

ErrorSvg.defaultProps = {
  version: "1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 536.33 207.11"
};
var Box = (0, _styledComponents["default"])(_slice.Box).attrs({
  mt: ['-24px', '-24px', 0],
  p: 4
})(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  text-align: center;\n"], ["\n  text-align: center;\n"])));
exports.Box = Box;
var ErrorPizza = (0, _styledComponents["default"])(ErrorSvg)(templateObject_2 || (templateObject_2 = (0, _tslib.__makeTemplateObject)(["\n  width: 140px;\n\n  ", " {\n    width: 180px;\n  }\n"], ["\n  width: 140px;\n\n  ", " {\n    width: 180px;\n  }\n"])), _slice.mediaQueries[1]);
exports.ErrorPizza = ErrorPizza;
var Headline = (0, _styledComponents["default"])(_slice.Headline).attrs({
  fontSize: 24
})(templateObject_3 || (templateObject_3 = (0, _tslib.__makeTemplateObject)(["\n  line-height: 1em;\n  margin-bottom: 16px;\n  margin-top: 24px;\n"], ["\n  line-height: 1em;\n  margin-bottom: 16px;\n  margin-top: 24px;\n"])));
exports.Headline = Headline;
var Modal = (0, _styledComponents["default"])(_slice.Modal)(templateObject_4 || (templateObject_4 = (0, _tslib.__makeTemplateObject)(["\n  width: auto;\n  margin: 100px 12px;\n\n  ", " {\n    margin: 5% auto;\n    max-width: 640px;\n  }\n"], ["\n  width: auto;\n  margin: 100px 12px;\n\n  ", " {\n    margin: 5% auto;\n    max-width: 640px;\n  }\n"])), _slice.mediaQueries[0]);
exports.Modal = Modal;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;